export const handleEnglishCharOnly = (value: string): string => {
  return value.replace(/[^0-9a-zA-Z]/g, '');
};
